import { useState } from 'react';
import { MuiOtpInput } from 'mui-one-time-password-input';
import { Box } from '@mui/system';
import { Typography, Button, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectUser } from 'store/user';
import { ModalTitle } from 'components';
import { withOutsideClickPreventer } from 'utils';

import styles from './TwoFactorPopupOff.module.scss';

type TwoFactorPopupOffProps = {
  open: boolean;
  onTurnOffTwoFactor: (code: string) => Promise<void>;
  onResendCode: () => void;
  onClose: () => void;
};

export const TwoFactorPopupOff = ({ open, onTurnOffTwoFactor, onResendCode, onClose }: TwoFactorPopupOffProps) => {
  const { t } = useTranslation('settings');
  const user: any = useSelector(selectUser);

  const [code, setCode] = useState<string>('');

  const handleInput = (value: string): void => {
    setCode(value);
    if (value.length === 6) onTurnOffTwoFactor(value);
  };

  const handleTurnOffTwoFactor = (codeValue?: string) => {
    onTurnOffTwoFactor(codeValue ?? code);
  };

  return (
    <Dialog open={open} onClose={withOutsideClickPreventer(onClose)} className={styles.dialog}>
      <DialogTitle>
        <ModalTitle title={t('securityPopups.turnOff2faTitle')} onClose={onClose} />
      </DialogTitle>

      <DialogContent className={styles.dialogContent}>
        <Typography variant='body2'>
          {t('securityPopups.verificationCodeSentEndingIn', { digits: user?.PhoneNumber?.slice(-4) })}
        </Typography>

        <MuiOtpInput
          className={styles.input}
          value={code}
          onChange={handleInput}
          length={6}
          autoFocus
          TextFieldsProps={{ InputProps: { componentsProps: { input: { pattern: '\\d*' } } } }}
        />

        <Typography variant='body1'>
          {t('securityPopups.didNotReceiveCodeClick')}
          <u onClick={onResendCode} className={styles.action}>
            {t('securityPopups.here')}
          </u>
          {t('securityPopups.toResendCode')}
        </Typography>

        <Box className={styles.buttonsContaine}>
          <Button variant='outlined' className={styles.button} onClick={onClose}>
            {t('securityPopups.cancel')}
          </Button>

          <Button variant='contained' className={styles.button} onClick={() => handleTurnOffTwoFactor()}>
            {t('securityPopups.turnOff2fa')}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
